import { UpdateBookingBusinessPageDocument } from '../graphql/mutations/__generated__/UpdateBookingBusinessPage.interface';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import type { UpdateBookingBusinessResponse, BookingBusinessEntryInput } from 'owa-graph-schema';
import bookingApolloMutate from '../utils/bookingApolloMutate';
import { hasError } from '../utils/apolloErrorHandler';
import type UpdateBookingBusinessResult from '../constants/updateBookingBusinessResult';
import fetchSourceHeaders from '../utils/fetchSourceHeaders';

const updateBookingBusinessPage = async (
    businessEntry: BookingBusinessEntryInput,
    source?: string
): Promise<UpdateBookingBusinessResult> => {
    const perfDatapoint = new PerformanceDatapoint('updateBookingBusinessPage');
    try {
        const response = await bookingApolloMutate(
            UpdateBookingBusinessPageDocument,
            {
                variables: { businessEntry },
                context: fetchSourceHeaders(source),
            },
            { source }
        );

        if (!hasError(response)) {
            perfDatapoint.addCustomData({
                entryPoint: source ?? 'booking',
            });
            perfDatapoint.end();
            return response.data?.updateBookingBusiness as UpdateBookingBusinessResponse;
        } else {
            perfDatapoint.endWithError(DatapointStatus.ServerError);
            return { ...response, hasError: true };
        }
    } catch (e) {
        perfDatapoint.endWithError(DatapointStatus.ServerError);
        return Promise.reject(new Error('Error in updateBookingBusinessPage'));
    }
};

export default updateBookingBusinessPage;
